"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
exports.default = (function (_a) {
    var children = _a.children, theme = _a.theme, className = _a.className, edge = _a.edge, highlight = _a.highlight, maxWidth = _a.maxWidth, truncate = _a.truncate, slim = _a.slim, breakWord = _a.breakWord, others = tslib_1.__rest(_a, ["children", "theme", "className", "edge", "highlight", "maxWidth", "truncate", "slim", "breakWord"]);
    var _b;
    return (React.createElement("td", tslib_1.__assign({}, others, { className: classnames_1.default(theme.cell, className, (_b = {},
            _b[theme.edge] = edge,
            _b[theme.highlight] = highlight,
            _b[theme.truncate] = truncate,
            _b[theme.breakWord] = breakWord,
            _b[theme.slim] = slim,
            _b)), style: { width: maxWidth } }),
        React.createElement("div", { className: theme.inner, style: { maxWidth: maxWidth } }, (children === undefined || children === null) ? "\u00A0" : children)));
});
